import {Outlet} from "react-router";

export function RouteComponent() {
    return <Outlet />;
}
